<template>
  <footer class="footer">
    <div class="wrap">
      <div>
        <h4>联系我们</h4>
        <p>地址：{{ siteConfig.address }}<br>电话：{{ siteConfig.phone }}<br>邮箱：{{ siteConfig.email }}</p>
      </div>
      <div>
        <h4>快速链接</h4>
        <ul>
          <li @click="go('/')">首页</li>
          <li @click="go('/firm-list')">企业展示</li>
          <li @click="go('/join-process')">入会流程</li>
          <li @click="go('/product-list')">产品展示</li>
          <li @click="go('/association-activity')">协会活动</li>
        </ul>
      </div>
      <div>
        <h4>关注我们</h4>
        <div class="qr-row">
          <div class="qr-item" v-for="q in qrList" :key="q.url">
            <div class="qr"><img :src="q.url" :alt="q.name" class="qr-image"/></div>
            <span class="qr-name">{{ q.name }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="copyright">Copyright © 2026 云南省供应链协会 版权所有 · 滇ICP备2022005988号</div>
  </footer>
</template>

<script setup>
import { useRouter } from 'vue-router';
import { ref, onMounted } from 'vue';
import { getLunboImages } from '@/api/mediaApi.js';
import { siteConfig } from '@/composables/useSiteConfig.js';
import qrGzh from '@/assets/images/公众号.jpg';
import qrSph from '@/assets/images/视频号.jpg';
import qrDy from '@/assets/images/抖音号.jpg';
import qrKs from '@/assets/images/快手号.jpg';

const router = useRouter();


// 兜底：后台未配置 footer_qrcode 媒体位时使用本地素材
const qrList = ref([
  { name: '公众号', url: qrGzh },
  { name: '视频号', url: qrSph },
  { name: '抖音号', url: qrDy },
  { name: '快手号', url: qrKs },
]);

onMounted(() => {
  // 从后台媒体管理读取"页脚二维码"媒体位（footer_qrcode）的图片
  getLunboImages({ positionsCode: 'footer_qrcode' }).then((res) => {
    if (res && res.code == 200 && Array.isArray(res.data) && res.data.length) {
      qrList.value = res.data.map((m) => ({
        name: m.name || '关注我们',
        url: m.publicizeAtt,
      }));
    }
  }).catch(() => {});
});

function go(path) {
  router.push(path);
}
</script>

<style scoped>
.footer {
  background: var(--color-primary-900);
  color: #9fb2d8;
  margin-top: 60px;
}

.footer .wrap {
  display: grid;
  grid-template-columns: 1.3fr 1fr 1fr;
  gap: 40px;
  padding: 52px 24px 36px;
}

.footer h4 {
  color: #fff;
  font-size: 17px;
  margin-bottom: 14px;
  letter-spacing: 1px;
}

.footer p {
  font-size: 14px;
  line-height: 2;
}

.footer ul {
  list-style: none;
}

.footer li {
  font-size: 14px;
  line-height: 2;
  cursor: pointer;
  transition: color var(--fast);
}

.footer li:hover {
  color: #fff;
}

.qr-row {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
}

.qr-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
}

.qr {
  width: 68px;
  height: 68px;
  background: #fff;
  border-radius: var(--r-sm);
  padding: 6px;
  box-sizing: border-box;
  overflow: hidden;
}

.qr-image {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.qr-name {
  font-size: 12px;
  color: #9fb2d8;
  line-height: 1;
}

.copyright {
  border-top: 1px solid rgba(255, 255, 255, .12);
  padding: 18px 0;
  font-size: 13px;
  text-align: center;
  color: #7e93c0;
}

@media (max-width: 960px) {
  .footer .wrap {
    grid-template-columns: 1fr;
    gap: 28px;
  }
}
</style>
